import { KalturaMediaAsset, KalturaProgramAsset } from '@kaltura-ott/ott-client-types/api/types';

import type { ButtonTypes, KuxProgram, TypeOfApplicationLink, AssetPresentationRatioEnum } from '../interfaces';
import { toKuxImages } from '../lib/utils/image';

import { getEpisodeMetas } from './asset-v2.helper';
import { KuXDms } from './dms';
import { toBoolean } from './utils/common';
import { getParentalRating, KalturaCategoryMetas, normalizeCategoryMetas, normalizeCategoryTags } from './utils/meta';
import { KalturaCategoryTags } from './utils/tags';

export const assetToLoginAsset = (asset: KalturaMediaAsset) => {
  const metas = normalizeCategoryMetas(asset.metas as KalturaCategoryMetas);
  return {
    id: asset.id,
    title: asset.name,
    inAppLink: metas['in_app_link'] as string,
    typeOfAppLink: metas['type_of_app_link'] as TypeOfApplicationLink,
    image: asset.images[0]?.url,
    type: metas['button_type'] as ButtonTypes,
  };
};

/**
 * TODO DEPRECATED
 */
export const assetToProgram = (
  program: KalturaProgramAsset,
  imageType?: number,
  imageRatio?: AssetPresentationRatioEnum,
): KuxProgram => {
  let originImage;
  if (imageType) {
    originImage = program.images.find((item) => item.imageTypeId === imageType);
  } else {
    originImage = program.images.find((item) => item.ratio === imageRatio);
  }

  const originImageUrl = originImage && originImage.url;
  const metas = normalizeCategoryMetas(program.metas as KalturaCategoryMetas);
  const tags = normalizeCategoryTags(program.tags as KalturaCategoryTags);
  const adult = toBoolean(metas['Adult']);
  const recordable = !adult && program.enableCdvr;

  return {
    id: program.id,
    type: program.type,
    originImage: originImageUrl || (program.images[0] && program.images[0].url),
    title: program.name,
    epgId: program.epgId,
    linearAssetId: program.linearAssetId,
    description: program.description,
    startDate: program.startDate * 1000,
    endDate: program.endDate * 1000,
    adult,
    metas,
    tags: normalizeCategoryTags(program.tags),
    images: toKuxImages(program.images),
    parentalRating: getParentalRating(tags),
    recordable,
    enableCdvr: program.enableCdvr,
    enableCatchUp: program.enableCatchUp,
    enableStartOver: program.enableStartOver,
    enableTrickPlay: program.enableTrickPlay,
    mediaType: KuXDms.mediaTypesValue[program.type],
    ...getEpisodeMetas(metas),
  };
};

/**
 *  Get array of page number needed for full download
 *
 * @param totalCount: number
 * @param chunkSize: number
 * @param startPage: number
 */
export const getPageNumberArr = (totalCount: number, chunkSize: number, startPage: number): number[] => {
  if (totalCount > chunkSize * (startPage - 1)) {
    return Array.from(
      { length: Math.ceil((totalCount - (startPage - 1) * chunkSize) / chunkSize) },
      (_, i) => i + startPage,
    );
  }
  return [];
};

export const sliceArrayOnChunks = (arr: number[], chunckSize: number): Array<number[]> =>
  arr.reduce((acc: number[][], curr, i) => {
    if (!(i % chunckSize)) {
      acc.push(arr.slice(i, i + chunckSize));
    }
    return acc;
  }, []);
